class Testimonial {
	constructor(el, testimonials) {
		this.el = el;
		this.testimonials = testimonials;
		this.video = el.querySelector('video');

		this.el.querySelector('[data-play-button]')?.addEventListener('click', () => this.playVideo());

		if (this.video) {
			this.video.addEventListener('playing', () => this.testimonials.stopVideos(this));
		}
	}

	playVideo() {
		if (!this.video) {
			return;
		}

		this.el.classList.add('video-active');
		this.video.play();
	}

	stopVideo() {
		if (!this.video) {
			return;
		}

		this.video.pause();
	}
}

export default class Testimonials {
	static init(e) {
		const els = e.detail.element.querySelectorAll('[data-testimonials]');
		els.forEach((el) => new this(el));
	}

	constructor(el) {
		this.el = el;
		this.testimonials = Array.from(this.el.querySelectorAll('[data-testimonial]')).map(
			(el) => new Testimonial(el, this)
		);
	}

	stopVideos(testimonial) {
		this.testimonials.forEach((t) => {
			if (t !== testimonial) {
				t.stopVideo();
			}
		});
	}
}
